import React, { useCallback, useEffect, useState } from "react";
import { Box, Text, Button, Grid, Label, Flex, Modal, ErrorMsg } from "atoms";
import { FormInput, FormRadio, FormSelect } from "molecules";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import MemoClose from "assets/icons/Close";
import { InvitationSentModal } from "../InvitationSentModal";
import { usePropsoch } from "contexts/Propsoch";
import api from "utils/api";

const micromarketGet = async () => {
  try {
    const { data } = await api("/micromarkets/get", {
      method: "get",
    });

    return data;
  } catch (e) {
    throw e;
  }
};

export const AddNewMicromarketModal = ({
  isOpen,
  onClose,
  title,
  isLocation = true,
  preRecord,
  onSubmit,
  loading,
  error,
  resetError,
}) => {
  const [isConfirmModalVisible, setConfirmModalVisible] = useState(false);

  const {
    state: { locations },
    actions: { getLocation },
  } = usePropsoch();

  const [locationLoading, setLocationLoading] = useState(false);
  const loadRoles = useCallback(() => {
    if (isLocation) {
      setLocationLoading((prev) => true);
      getLocation()
        ?.then(() => {})
        .finally(() => {
          setLocationLoading(false);
        });
    }
  }, [getLocation, isLocation]);

  useEffect(() => {
    loadRoles();
  }, [loadRoles]);

  const [micromarkets, setMicromarkets] = useState([]);

  useEffect(() => {
    micromarketGet().then((data) => {
      setMicromarkets(data?.data);
    });
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <Box width={{ md: "48.8rem" }}>
          <Box p={{ xs: "2.4rem", lg: "3.2rem" }}>
            <Flex
              justifyContent="space-between"
              borderBottom="0.1rem solid"
              borderColor="neutral.100"
              pb="2.4rem"
            >
              <Text
                fontSize="2rem"
                color="primary.900"
                fontFamily="primaryBold"
              >
                {preRecord ? "Edit" : "Add New"} {title || ""}
              </Text>
              <Box
                color="neutral.900"
                onClick={onClose}
                cursor="pointer"
                textAlign="right"
              >
                <MemoClose height="1.6rem" width="1.6rem" />
              </Box>
            </Flex>
            <Formik
              initialValues={{
                id: preRecord?.id || "",
                name: preRecord?.name || "",
                linkedMicromarkets: preRecord?.linkedMicromarkets || [],
                ...(isLocation
                  ? { locationId: preRecord?.locationId || "" }
                  : {}),
                isPopular:
                  typeof preRecord?.isPopular === "boolean"
                    ? preRecord?.isPopular
                    : "",
              }}
              onSubmit={onSubmit}
              validationSchema={Yup.object().shape({
                name: Yup.string().required("Name is required"),
                ...(isLocation
                  ? {
                      locationId: Yup.string().required("Location is required"),
                    }
                  : {}),
                isPopular: Yup.boolean().required(
                  "Choose yes if micromarket is popular"
                ),
              })}
            >
              {({ values, setFieldValue, touched, errors }) => {
                return (
                  <Form>
                    <Grid gridRowGap="2.4rem" mt="1.8rem">
                      <Grid gridRowGap="1.6rem">
                        <Label text="Name" req />
                        <FormInput
                          name="name"
                          placeholder="Enter Name"
                          autoFocus
                          req
                          onChange={(e) => {
                            setFieldValue("name", e?.target?.value);
                            error && resetError();
                          }}
                        />
                      </Grid>
                      {isLocation && (
                        <Grid gridRowGap="1.6rem">
                          <Label text="Location" req />
                          <FormSelect
                            name="locationId"
                            placeholder="Enter Location"
                            req
                            onChange={(e) => {
                              // setFieldValue("role", e?.target?.value);
                              error && resetError();
                            }}
                            isLoading={locationLoading}
                            options={locations?.map((role) => ({
                              label: role?.name,
                              value: role?.id,
                            }))}
                          />
                        </Grid>
                      )}

                      <Flex aI="center" gridGap="3rem">
                        <Label text="Popular" req />
                        <FormRadio name="isPopular" label="Yes" value={true} />
                        <FormRadio name="isPopular" label="No" value={false} />
                      </Flex>

                      {touched?.isPopular && errors?.isPopular && (
                        <ErrorMsg text={errors?.isPopular} />
                      )}

                      <Grid gridRowGap="1.6rem">
                        <Label text="Linked Micromarkets" />
                        <FormSelect
                          name="linkedMicromarkets"
                          placeholder="Linked Micromarkets"
                          req
                          onChange={(e) => {
                            // setFieldValue("role", e?.target?.value);
                            error && resetError();
                          }}
                          isLoading={locationLoading}
                          options={micromarkets
                            ?.map((role) => ({
                              label: role?.name,
                              value: role?.id,
                              data: role,
                            }))
                            ?.filter(
                              (i) =>
                                i?.data?.locationId === values?.locationId &&
                                i?.value !== values?.id
                            )}
                          isMulti
                          isDisabled={!values?.locationId}
                        />
                      </Grid>
                      {error && <ErrorMsg text={error} />}

                      <Button
                        variant="primary"
                        type="submit"
                        height={{ xs: "4.3rem", lg: "4.8rem" }}
                        loading={loading}
                      >
                        Save
                        {/* {preRecord ? "Edit" : "Add"} */}
                      </Button>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        </Box>
      </Modal>
      {isConfirmModalVisible && (
        <InvitationSentModal
          isOpen={isConfirmModalVisible}
          onClose={() => setConfirmModalVisible(false)}
        />
      )}
    </>
  );
};
